module.exports = __webpack_public_path__ + "img/success2.d355163b.svg";